import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const SaveContact = async (contacts,navigate) => {
  const accesstoken = getToken();

  if (accesstoken) {
    try {
        let Payload =[];
        for(var i = 0; i< contacts.length; i++){
            Payload.push( {
                "contactID" : contacts[i].contactID,
                "customerID": contacts[i].customerID,              
                "firstName": contacts[i].firstName,
                "lastName":  contacts[i].lastName,              
                "jobTitle": contacts[i].jobTitle,
                "email": contacts[i].email,       
                "phoneNumbers": contacts[i].phoneNumbers,
                "isPrimary": contacts[i].isPrimary,
                "status": contacts[i].status,
              }) 
        }         

          console.log(Payload);
      const response = await fetch(`${dev_baseUrl}/Contact/saveContact`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(Payload),
      });
      
      const data = await response.json();                      
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else if(response.ok && !data.isError ){      
        return data;
      }      
    } catch (error) {
      console.error('Network error:', error);
      return { isError:true, message: 'An error occurred. Please try again later.' , error: error};
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};
